export default {"src":"/_next/static/media/gift_24.201e6af9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};